/* Albums API — AI auto-grouping of trip photos. */
import { USE_MOCK_API } from './httpClient'
import * as mock from './albums.mock'
import * as http from './albums.http'
import type { AutoAlbumsResult } from './types'

const impl = USE_MOCK_API ? mock : http

export type { AutoAlbum, AutoAlbumsResult } from './types'

export const getAutoAlbums: (tripId: string) => Promise<AutoAlbumsResult> = impl.getAutoAlbums
export const applyAlbumPicks: (tripId: string, mediaIds: string[]) => Promise<{ updated: number }> =
  impl.applyAlbumPicks
